import styled from 'styled-components';
import { Media } from 'enums';
import { Button } from 'view/atoms';

export const RequestCountWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 50%;
  background-color: #fff;

  @media ${Media.mobile} {
    width: 24px;
    height: 24px;
    margin-left: 8px !important;
  }

  @media ${Media.notebook} {
    width: 28px;
    height: 28px;
    margin-left: 10px !important;
  }
`;

export const RequestDiscountButton = styled(Button)`
  width: 240px;
  height: 56px;

  @media ${Media.notebook} {
    margin-right: 16px;
  }
`;
